module.exports = "<div class='error-block'>\n  <p>{{msgMain}}<br/>\n    <a class='error-msg-mail-style' ng-show=\"showMail\" href=\"mailto:zsin.cr@gugik.gov.pl\" target=\"_blank\">zsin.cr@gugik.gov.pl</a>\n  </p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-view/error-view.component.html
// module id = ./src/app/components/error-view/error-view.component.html
// module chunks = main